import { useState, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, IconButton, InputAdornment, TextField, Tooltip, lighten, Typography, darken, useTheme } from '@mui/material';

import { ReactComponent as Accountkey } from '../../assets/icons/main/account-key-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/main/close-icon.svg';
import CustomDataTable from '../../components/CustomDataTable';
import CustomSwitch from '../../components/CustomSwitch';
import MultiSelect from '../../components/MultiSelect';
import { debounce, get, isEmpty, reduce } from 'lodash';
import CheckboxComponent from '../../components/Checkbox';
import { ReactComponent as AvatarIcon } from '../../assets/icons/main/person-icon.svg';
import { userManagementActions } from '../../store/reducers/user-management';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import AddEditUser from './addEditUser';
import { UserFormData, UsersDataRequestPayloadTypes } from '../../store/models/user-management';
import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import PopUp from '../../components/Popup';
import { ReactComponent as CreateIcon } from '../../assets/icons/main/create-icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/main/delete-icon.svg';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { userRoleActions } from '../../store/reducers/user-role';
import { useOutletContext } from 'react-router-dom';
import {palette} from '../../theme/palette';



const statusOptions = [
  { id: 0, label: 'All', value: 'all' },
  { id: 1, label: 'Enabled', value: true },
  { id: 2, label: 'Disabled', value: false },
];

interface UserListTypes {
  isUserListLoading: boolean;
  userList: any;
  userListTotalCount: number;
  userListPageNumber: number;
  userRole: any;
  isAddUserLoading: boolean;
  isAddUserLoadingSuccess: boolean;
  isUpdateUserSuccess: boolean;
  isDeleteUserSuccess: boolean;
  isDeleteUserError: boolean;
  userManagementMessage: string;
  userListError: boolean;
  isAddUserError: boolean;
  isUpdateUserError: boolean;
  setSelectedRows: any;
  selectedRows: any;
  setAddPopupOpen: any;
  addPopupOpen: any;
  isEdit: any;
  setIsEdit: any;
  selectedRole: any;
  setSelectedRole: any;
  userDetails: any;
  setUserDetails: any;
  showUserDetails: any;
  setShowUserDetails: any;
  confirmPopup: any;
  setConfirmPopup: any;
  userIds: any;
  setUserIds: any;
  userAccess: any;
}

interface FieldNameTypes {
  full_name: string;
  roles: string;
  email: string;
  enabled: string;
}

const userFormData: UserFormData = {
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  credentails: [{ type: 'password', value: '' }],
  role: '',
};

function UserList({
  isUserListLoading,
  userList,
  userListTotalCount,
  userListPageNumber,
  userRole,
  isAddUserLoadingSuccess,
  isUpdateUserSuccess,
  isDeleteUserSuccess,
  setSelectedRows,
  selectedRows,
  setAddPopupOpen,
  addPopupOpen,
  isEdit,
  setIsEdit,
  selectedRole,
  setSelectedRole,
  userDetails,
  setUserDetails,
  showUserDetails,
  setShowUserDetails,
  confirmPopup,
  setConfirmPopup,
  userIds,
  setUserIds,
  userAccess,
}: UserListTypes) {

  const themeData :any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  const Styles = {
    cellText: {
      fontSize: '1rem',
      marginLeft: '10px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      color: themeData.palette.text.secondary,

      '&.disabled': {
        opacity: 0.5,
        userSelect: 'none',
      },
    },

    avatarWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: (themeMode.isLightBG) ? darken(themeData.palette.background.default, 0.1) : lighten(themeData.palette.background.default, 0.2) ,
      width: '30px',
      height: '30px',
      padding: '5px',
      borderRadius: '50px',

      '&.disabled': {
        opacity: 0.5,
        userSelect: 'none',
      },
    },
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filterObj, setFilterObj] = useState<any>({ user_name: '', user_email: '', user_roles: [], user_statuses: [] });
  const [userData, setUserData] = useState<UserFormData>(userFormData);
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
  const [params, setParams] = useState({});

  const dispatchUserListRequest = (payload: UsersDataRequestPayloadTypes) => {
    dispatch(userManagementActions.getUserList({ ...sortingModel, ...params, ...payload }));
  };

  // const auth: any = useAuth();
  // const authUserEmail = get(auth, 'user.profile.email', '');

  useEffect(() => {
    if (userAccess.read) {
      dispatchUserListRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER });
      dispatch(userRoleActions.getRoleList());
    }
  }, [userAccess.read]);

  // useEffect(() => {
  // if (userList.length) {
  //   const filteredRows = userList
  //     .filter((user: any) => user.email !== authUserEmail)
  //     .map((users: any) => ({
  //       ...users,
  //       name: `${users.firstName} ${users.lastName}`,
  //     }));
  //   setUsersList(filteredRows);
  // }
  // }, [authUserEmail, userList]);

  // const filteredList = useMemo(() => {
  //   return userList.filter((user: any) => {
  //     return Object.keys(filterObj).every((obj: string) => {
  //       if (!isBoolean(user[obj]) && isEmpty(filterObj[obj])) {
  //         return true;
  //       } else {
  //         if (typeof user[obj] === 'string') {
  //           return (user[obj] || '').toLowerCase().includes(filterObj[obj].toLowerCase());
  //         } else if (obj === 'roles') {
  //           return user[obj].some((item: any) => filterObj[obj].includes(item.id));
  //         } else if (obj === 'enabled' && filterObj[obj].length) {
  //           return filterObj[obj].includes(user[obj]);
  //         } else {
  //           return true;
  //         }
  //       }
  //     });
  //   });
  // }, [userList, filterObj]);

  const handleMultipleActions = (payload: any, type: string) => {
    if (type === 'edit') {
      setIsEdit(true);
      setSelectedRole(get(payload, 'roles[0].id', ''));
      setUserData(payload);
      setAddPopupOpen(true);
    } else if (type === 'delete') {
      setUserData(payload);
      setUserIds([payload]);
      setConfirmPopup(true);
    } else if (type == 'warning') {
      setUserData(userFormData);
      setConfirmPopup(false);
    } else if (type == 'success') {
      setShowUserDetails(false);
      dispatch(userManagementActions.resetLoadingState());
    } else if (type == 'confirm') {
      dispatch(userManagementActions.deleteMultipleUserRequest(userIds));
      setSelectedRows([]);
      setUserData(userFormData);
      setConfirmPopup(false);
    }
  };

  const onChangeDispatch = useMemo(
    () =>
      debounce((params) => {
        const payload = reduce(
          params,
          (acc: any, value, key) => {
            if (!isEmpty(value) && Array.isArray(value)) {
              acc[key] = value.join(',');
            }
            if (!isEmpty(value) && typeof value === 'string' && value.trim()) {
              acc[key] = value.trim();
            }
            return acc;
          },
          {}
        );
        setParams(payload);
        dispatchUserListRequest({
          limit: DEFAULT_PAGE_SIZE,
          page: DEFAULT_PAGE_NUMBER,
          ...payload,
        });
      }, 500),
    [sortingModel]
  );

  const onSearch = (name: string, value: string) => {
    setFilterObj((pre: any) => ({ ...pre, [name]: value }));
    onChangeDispatch({ ...filterObj, [name]: value });
  };

  const onFilterDispatch = (pars: any) => {
    const payload = reduce(
      pars,
      (acc: any, value, key) => {
        if (!isEmpty(value) && Array.isArray(value)) {
          acc[key] = value.join(',');
        }
        if (!isEmpty(value) && typeof value === 'string' && value.trim()) {
          acc[key] = value.trim();
        }
        return acc;
      },
      {}
    );
    setParams(payload);
    dispatch(
      userManagementActions.getUserList({
        ...sortingModel,
        limit: DEFAULT_PAGE_SIZE,
        page: DEFAULT_PAGE_NUMBER,
        ...payload,
      })
    );
  };

  const onFilter = (selection: string, value: string | string[]) => {
    let filterData = {};
    setFilterObj((pre: any) => {
      filterData = {
        ...pre,
        [selection]: typeof value === 'string' ? pre[selection].filter((option: string) => option !== value) : value,
      };
      return { ...filterData };
    });
    onFilterDispatch(filterData);
  };

  const handleRowSelection = (event: any, params: any) => {
    if (selectedRows.includes(params)) {
      setSelectedRows(selectedRows.filter((row: any) => row !== params));
    } else {
      setSelectedRows([...selectedRows, params]);
    }
  };

  const handleToggle = (payload: any) => {
    if (payload.enabled) {
      const newObj: any = { id: payload.id, email: payload.email, enabled: false };
      dispatch(userManagementActions.updateUserRequest(newObj));
    } else {
      const newObj: any = { id: payload.id, email: payload.email, enabled: true };
      dispatch(userManagementActions.updateUserRequest(newObj));
    }
  };

  const handleUserAccess = (rowId: any) => {
    navigate(`/user-management/${rowId}/user-access-control`, { state: rowId });
  };

  const textToCopy = `Username: ${userDetails?.username}\nPassword : ${userDetails?.password}`;

  useEffect(() => {
    if (isAddUserLoadingSuccess || isUpdateUserSuccess || isDeleteUserSuccess) {
      dispatchUserListRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isDeleteUserSuccess && userList.length === 1 && userListPageNumber !== 1
            ? userListPageNumber - 1
            : userListPageNumber,
      });
    }
  }, [isAddUserLoadingSuccess, isUpdateUserSuccess, isDeleteUserSuccess]);

  useEffect(() => {
    if (isAddUserLoadingSuccess) {
      setShowUserDetails(true);
    }
  }, [isAddUserLoadingSuccess]);


  const columns: any = [
    {
      sortable: false,
      headerName: '',
      minWidth: 20,
      width: '20px',
      renderCell: (params: any) => {
        const disableDelete = !params.row.is_allowed;
        return (
          <CheckboxComponent
            checked={selectedRows.includes(params.row.id)}
            handleCheckboxChange={(event: any) => handleRowSelection(event, params.row.id)}
            disabled={disableDelete}
            style={{ padding: '0px' }}
          />
        );
      },
    },
    {
      field: 'full_name',
      headerName: 'NAME',
      sortable: true,
      resizable: false,
      flex: 1,
      customFilterReq: true,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      width: '200px',
      renderCell: (params: any) => {
        const isNotAllowed = !params.row.is_allowed;
        const disableUpdate = !params.row.is_allowed || !userAccess.update;
        return (
          <Box
            sx={{ width: '240px', display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}
          >
            {/* <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // backgroundColor: lighten(themeData.palette.primary.light,0.2),
                backgroundColor: (themeMode.isLightBG) ? darken(themeData.palette.background.default, 0.1) : lighten(themeData.palette.background.default, 0.1),
                width: '30px',
                height: '30px',
                padding: '5px',
                borderRadius: '50px',
              }}
            > */}
            <Box className={isNotAllowed ? 'disabled' : ''} sx={Styles.avatarWrapper}>
              <AvatarIcon />
            </Box>
            <Tooltip title={!isNotAllowed && params.value} arrow>
              <Typography
                variant='body2'
                component='span'
                className={isNotAllowed ? 'disabled' : ''}
                sx={Styles.cellText}
              >
                {params.value}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'email',
      headerName: 'EMAIL ADDRESS',
      flex: 1,
      sortable: true,
      resizable: false,
      customFilterReq: true,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      width: '200px',
      renderCell: (params: any) => {
        const isNotAllowed = !params.row.is_allowed;
        const disableUpdate = !params.row.is_allowed || !userAccess.update;
        return (
          <Box sx={{ width: '240px', display: 'flex' }}>
            <Tooltip title={!isNotAllowed && params.value} arrow>
              <Typography
                variant='body2'
                component='span'
                className={isNotAllowed ? 'disabled' : ''}
                sx={Styles.cellText}
              >
                {params.value}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'roles',
      headerName: 'ROLE',
      flex: 1,
      sortable: true,
      resizable: false,
      customDropdownFilterReq: true,
      options: userRole.map((role: any) => ({ ...role, label: role.name, value: role.name })),
      isMultiSelect: true,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      width: '120px',
      renderCell: (params: any) => {
        const isNotAllowed = !params.row.is_allowed;
        const roleName = params.value.map((item: any) => item.name);

        return (
          <Box sx={{ width: '240px', display: 'flex' }}>
            <Tooltip title={!isNotAllowed && roleName} arrow>
              <Typography
                variant='body2'
                component='span'
                className={isNotAllowed ? 'disabled' : ''}
                sx={Styles.cellText}
              >
                {roleName}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'enabled',
      headerName: 'STATUS',
      flex: 1,
      sortable: true,
      resizable: false,
      colType: 'custom',
      headerAlign: 'left',
      align: 'left',
      customDropdownFilterReq: true,
      options: statusOptions,
      minWidth: 100,
      width: '100px',
      renderCell: (params: any) => {
        const disableUpdate = !params.row.is_allowed || !userAccess.update;
        return (
          <CustomSwitch
            checked={params.value}
            onChange={() => {
              if (disableUpdate) return;
              handleToggle(params.row);
            }}
            disabled={disableUpdate}
          />
        );
      },
    },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      customFilterReq: false,
      minWidth: 90,
      width: '90px',
      renderCell: (params: any) => {
        const disableUpdate = !params.row.is_allowed || !userAccess.update;
        const disableDelete = !params.row.is_allowed || !userAccess.delete;
        return (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
            <IconButton sx={{padding:0}} onClick={() => handleMultipleActions(params.row, 'edit')} disabled={disableUpdate}>
              <CreateIcon
                style={{
                  cursor: 'pointer',
                  width: 24,
                  height: 24,
                  opacity: disableUpdate ? 0.5 : 1,
                  color: themeData.palette.custom.light,
                }}
              />
            </IconButton>
            <IconButton sx={{padding:0}} onClick={() => handleMultipleActions(params.row.id, 'delete')} disabled={disableDelete}>
              <DeleteIcon
                style={{
                  cursor: 'pointer',
                  width: 24,
                  height: 24,
                  opacity: disableDelete ? 0.5 : 1,
                  color: themeData.palette.custom.light,
                }}
              />
            </IconButton>
            <IconButton sx={{padding:0}} onClick={() => handleUserAccess(params.row.id)} disabled={disableUpdate}>
              <Accountkey
                style={{
                  cursor: 'pointer',
                  width: 24,
                  height: 24,
                  opacity: disableUpdate ? 0.5 : 1,
                  color: themeData.palette.custom.light,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const filterRow = [
    {
      id: 1,
    },
    {
      id: 2,
      field: 'name',
      renderCell: (params: any) => {
        return (
          <TextField
            value={filterObj['user_name']}
            name={params.field}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('user_name', e.target.value)}
            autoComplete='off'
            placeholder='User Name'
            sx={{ minWidth: '100px', width: 242, fontStyle: 'italic' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                  {filterObj['user_name'] && (
                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity:'0.7'}} onClick={() => onSearch('user_name', '')} />
                  )}
                </InputAdornment>
              ),
            }}
          />
        );
      },
    },
    {
      id: 3,
      field: 'email',
      renderCell: (params: any) => {
        return (
          <TextField
            value={filterObj['user_email']}
            name={params.field}
            autoComplete='off'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('user_email', e.target.value)}
            placeholder='Email Address'
            sx={{ minWidth: '100px', width: 242, fontStyle: 'italic' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                  {filterObj['user_email'] && (
                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity:'0.7' }} onClick={() => onSearch('user_email', '')} />
                  )}
                </InputAdornment>
              ),
            }}
          />
        );
      },
    },
    {
      id: 4,
      field: 'roles',
      minWidth: '100px',
      renderCell: (params: any) => (
        <MultiSelect
          selectedOptions={filterObj['user_roles']}
          options={userRole.map((role: any) => ({ id: role.id, label: role.name, value: role.id }))}
          onChange={(value: string[]) => {
            onFilter('user_roles', value);
          }}
          showSelectedLabels
          width={params.width}
          placeholder={'Role'}
        />
      ),
    },
    {
      id: 5,
      field: 'enabled',
      minWidth: '100px',
      renderCell: (params: any) => (
        <MultiSelect
          showSelectedLabels
          selectedOptions={filterObj['user_statuses']}
          options={[
            { id: true, name: true, label: 'Enabled', value: true },
            { id: false, name: false, label: 'Disabled', value: false },
          ]}
          onChange={(value: string[]) => {
            onFilter('user_statuses', value);
          }}
          width={params.width}
          placeholder={'Status'}
        />
      ),
    },
    {
      id: 6,
    },
  ];

  const closeModal = () => {
    setAddPopupOpen(false);
    setIsEdit(false);
    setUserData(userFormData);
    setSelectedRole('');
  };
 console.log(userData, 'Data')
  const renderModal = () => (
    <AddEditUser
      isOpen={addPopupOpen}
      userData={userData}
      setUserData={setUserData}
      isEdit={isEdit}
      handleClose={closeModal}
      setUserDetails={setUserDetails}
      rolesData={userRole.filter((role: any) => role.is_allowed)}
      selectedRole={selectedRole}
      setSelectedRole={setSelectedRole}
    />
  );

  return (
    <>
      <CustomDataTable
        rows={userList}
        columns={columns}
        filterRow={filterRow}
        tableHeight='calc(100vh - 400px)'
        loading={isUserListLoading}
        isServerPagination
        totalRowCount={userListTotalCount}
        page={userListPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchUserListRequest({ limit: pageSize, page: pageNumber });
        }}
        onSorting={({ field, sort }: { field: string; sort: string }) => {
          const getFieldName: FieldNameTypes = {
            full_name: 'full_name',
            roles: 'role_name',
            email: 'email',
            enabled: 'enabled',
          };
          const sortModel = { field: getFieldName[field as keyof FieldNameTypes], sort };
          dispatchUserListRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: userListPageNumber,
            ...sortModel,
          });
          setSortingModel(sortModel);
        }}
      />
      <PopUp
        title='SUCCESS'
        open={showUserDetails}
        icon={<SuccessIcon  style={{ color: palette.success.dark }}  />}
        message='New User added'
        showUserDetails
        userDetails={userDetails}
        textToCopy={textToCopy}
        confirmation
        confirmLabel='OK'
        onConfirm={() => handleMultipleActions({}, 'success')}
        onClose={() => handleMultipleActions({}, 'success')}
      />

      <PopUp
        open={confirmPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message='Are you sure to delete this User?'
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handleMultipleActions({}, 'confirm')}
        onClose={() => handleMultipleActions({}, 'warning')}
        onCancel={() => handleMultipleActions({}, 'warning')}
      />
      {renderModal()}
    </>
  );
}

const mapStateToProps = (state: any) => ({
  userList: state.userManagement.userList,
  userListTotalCount: state.userManagement.userListTotalCount,
  userListPageNumber: state.userManagement.userListPageNumber,
  userRole: state.userRole.userRole,
  isUserListLoading: state.userManagement.isUserListLoading,
  isAddUserLoading: state.userManagement.isAddUserLoading,
  isAddUserLoadingSuccess: state.userManagement.isAddUserLoadingSuccess,
  isUpdateUserSuccess: state.userManagement.isUpdateUserSuccess,
  isDeleteUserSuccess: state.userManagement.isDeleteUserSuccess,
  isDeleteUserError: state.userManagement.isDeleteUserError,
  userListError: state.userManagement.userListError,
  userManagementMessage: state.userManagement.userManagementMessage,
  isAddUserError: state.userManagement.isAddUserError,
  isUpdateUserError: state.userManagement.isUpdateUserError,
});

export default connect(mapStateToProps)(UserList);
